module.exports = __webpack_public_path__ + "h5/img/right-image.cc412c6e.png";